/**
 * Трансформируем ссылку для нашей темы
 * @param {string} path - ссылка
 * @returns {string} преопразованная ссылка
 */
export const transformPath = (path: string) => {
  let newPath = path || ''

  // Бэкенд может вернуть ссылку для SPA темы Kama с префиксом `spa:`. Убираем его
  newPath = newPath.replace(/^spa:/, '')

  // Обработка summary_documents
  if (newPath.includes('summary_documents')) {
    newPath = newPath.replace('/directory', '')
  }

  // Обработка /add - добавляем tab=add как query параметр
  if (newPath.includes('/add')) {
    newPath = newPath.replace('/add', '')

    // Определяем, есть ли уже query параметры
    const hasQuery = newPath.includes('?')
    const tabParam = 'tab=add'

    if (hasQuery) {
      // Если есть другие query параметры, добавляем &tab=add
      newPath += `&${tabParam}`
    } else {
      // Если нет query параметров, добавляем ?tab=add
      newPath += `?${tabParam}`
    }
  }

  // Остальные замены
  newPath = newPath.replace('/item', '').replace('/#!', '').replace('#!/', '/')

  return newPath
}

/**
 * Трансформируем HTML-строку, заменяя ссылки в ней результатом вызова функции transformPath
 * @param {string} html - HTML-строка
 * @returns {string} преобразованная HTML-строка
 */
export const transformPathFromHtml = (html: string | null) => {
  if (!html) return ''

  // Создаём временный контейнер для парсинга HTML-строки
  const container = document.createElement('div')
  container.innerHTML = html

  // Находим все ссылки <a>
  const links = container.querySelectorAll('a[href]')

  links.forEach(link => {
    const originalHref = link.getAttribute('href')
    if (originalHref) {
      const transformed = transformPath(originalHref)
      link.setAttribute('href', transformed)
    }
  })

  // Возвращаем модифицированную HTML-строку
  return container.innerHTML
}
